import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SyncIcon from "@mui/icons-material/Sync";
import FullCalendar from "@fullcalendar/react";
import allLocales from "@fullcalendar/core/locales-all";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import multiMonthPlugin from "@fullcalendar/multimonth";
import dayGridPlugin from "@fullcalendar/daygrid";
import { deleteRecord, fetchList } from "../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import Loader from "../../layout/Loader";
import DialogForm from "../../shared/components/DialogForm";
import SpinnerGlobal from "../../layout/SpinnerGlobal";
import {
  marketHotelListFailed,
  marketHotelListSuccess,
} from "../../Reducer/roomRateSlice";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import {
  marketAnalysisCalenderViewSuccess,
  marketAnalysisEventssSuccess,
  marketAnalysisOwnHotelIdSuccess,
  marketAnalysisResourcesSuccess,
} from "../../Reducer/revenueGenerationSlice";
import { convertToKeyValue, getMinDateForLimited } from "../../utils/helper";

const ExelJS = require("exceljs");

const MarketAnalysis = (props) => {
  const {
    marketHotelList,
    marketHotelListSuccess,
    calenderView,
    ownHotelId,
    resources,
    eventss,
    marketAnalysisCalenderViewSuccess,
    setOwnHotelId,
    setResourcess,
    setreservationEventss,
  } = props;

  const calendarRef = useRef(null);
  const [arg, setArg] = useState();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingRate, setLoadingRate] = useState(false);
  const [addMarketRatesDialog, setAddMarketRatesDialog] = useState(false);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("userDetails"));
    if (items) {
      setOwnHotelId(items.hotel_id);
    }
  }, []);

  const [marketFilters, setMarketFilters] = useState({
    startDate: moment().add(1, "days").format("YYYY-MM-DD"),
    endDate: moment().add(8, "days").format("YYYY-MM-DD"),
  });

  const setCalenderView = (props) => {
    marketAnalysisCalenderViewSuccess(convertToKeyValue(props));
  };

  const handlePrev = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
     
      calendarApi.prev();
    }
  };

  const handleNext = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
    
      calendarApi.next();
    }
  };

  const handleToday = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      
      calendarApi.today();
    }
  };

  const [deleteHotel, setDeleteHotel] = useState(null);
  const [openDeleteHotelDialog, setOpenDeleteHotelDialog] = useState(false);

  const handleCloseDeleteHotelDialog = () => {
    setOpenDeleteHotelDialog(false);
    setDeleteHotel(null);
  };

  const handleOpenDeleteHotelDialog = (id) => {
    setOpenDeleteHotelDialog(true);
    setDeleteHotel(id);
  };

  const handleConfirmDeleteHotel = async () => {
    setOpenDeleteHotelDialog(false);
    setLoading(true);
    const result = await deleteRecord(
      deleteHotel,
      ApiEndPoints.DELETE_MARKET_ANALYSIS_HOTEL
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      handleGetResources();
    } else {
      setLoading(false);
      toast.error(t(result.message));
    }
    handleCloseDeleteHotelDialog();
  };

  const columns = [
    {
      headerContent: t("Actions"), // Column title
      width: 100,
      cellClassNames: ["custom-resource-cell"],
      cellContent: (args) => {
        return args?.resource?.id === "average" ? (
          ""
        ) : (
          <button
            onClick={() => handleOpenDeleteHotelDialog(args.resource.id)}
            style={{
              padding: "5px 5px 2px",
              background: "orange",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <CancelIcon />
          </button>
        );
      },
    },
    {
      field: "competitor_hotel_name",
      cellClassNames: ["custom-resource-cell"],
      headerContent: t("Hotel Name"),
    },
  ];

  const handleGetResources = async () => {
    if(marketHotelList?.length <= 1){
      setLoading(true);
    }
    const result = await fetchList(
      ApiEndPoints.GET_MARKET_ANALYSIS_HOTEL_LIST +
        `?page_no=${1}&items_per_page=${1000}`
    );
    if (result?.status === 200) {
      marketHotelListSuccess([
        ...result?.data?.rows,
        { competitor_hotel_name: t("Average Price"), id: "average" },
      ]);
      // console.log(result?.data?.rows);
      setLoading(false);
    } else {
      marketHotelListSuccess([
        {
          competitor_hotel_name: "None",
        },
      ]);
      setLoading(false);
    }
  };

  useEffect(() => {
    setResourcess(marketHotelList);
  }, [marketHotelList]);

  const handleGetRateData = async (arg) => {
    if(eventss?.length === 0){
      setLoadingRate(true);
    }
    const result = await fetchList(
      ApiEndPoints.GET_MARKET_ANALYSIS_RATE +
        `?start_date=${moment(arg?.startStr).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(arg?.endStr).format("YYYY-MM-DD")}`
    );
    if (result?.status === 200) {
      let data = result?.data?.map((item) => ({
        start: moment(item?.date).format("YYYY-MM-DD"),
        resourceId: item?.competitor_hotel_id,
        title: item?.rate,
        textColor: "black",
        color: "transparent",
      }));

      let allDates = [];
      const startDate = moment(arg?.startStr);
      const endDate = moment(arg?.endStr);
      for (
        let m = moment(startDate);
        m.isSameOrBefore(endDate);
        m.add(1, "day")
      ) {
        const formattedDate = m.format("YYYY-MM-DD");
        allDates.push(formattedDate);
      }
      allDates.forEach((date) => {
        let avgFilData = data?.filter(
          (it) =>
            it?.start === date &&
            resources?.map((item) => item?.id)?.includes(it?.resourceId)
        );
        let avgPrice =
          avgFilData?.reduce((sum, item) => sum + +item.title, 0) /
          avgFilData.length;
        data.push({
          start: date,
          resourceId: "average",
          title: avgPrice ? avgPrice?.toFixed(2) : "-",
          textColor: "black",
          color: "transparent",
        });
      });
      allDates.forEach((date) => {
        resources.forEach((resId) => {
          let findData = data?.find(
            (it) => it?.resourceId === resId?.id && it?.start === date
          );

          if (!findData) {
            data.push({
              start: date,
              resourceId: resId?.id,
              title: "-",
              textColor: "black",
              color: "transparent",
            });
          }
        });
      });
      if (JSON.stringify(data) !== JSON.stringify(eventss)) {
        setreservationEventss(data);
        }
      setLoadingRate(false);
    } else {
      setreservationEventss([]);
      setLoadingRate(false);
    }
  };

  const handleAddMarketRates = async () => {
    let diff = moment(marketFilters?.endDate).diff(
      marketFilters?.startDate,
      "days"
    );
    if (diff < 0) {
      toast.error("Please, Enter Correct End Date");
      return;
    }
    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.ADD_MARKET_ANALYSIS_RATES +
        `?hotel_id=${ownHotelId}&days=${diff}&start_date=${marketFilters?.startDate}&end_date=${marketFilters?.endDate}`
    );
    if (result?.status === 200) {
      toast.success(result?.message);
      setAddMarketRatesDialog(false);
      setLoading(false);
      handleGetRateData(arg);
    } else {
      setLoading(false);
      toast.error(result?.message);
    }
  };

  useEffect(() => {
    handleGetResources();
  }, []);

  useEffect(() => {
    if (arg?.startStr !== arg?.endStr && arg && resources?.length > 0)
      handleGetRateData(arg);
  }, [arg, resources]);

  const exportToExcel = (dataHead, data,dateArray, title) => {
    // console.log(dataHead,data, 634 )
    const workbook = new ExelJS.Workbook();
    const sheet = workbook.addWorksheet("Market rate");
    sheet.columns = dataHead?.map((item, ind) => ({
      key: item,
      width: ind === 0 ? 100 : 20,
    }));

    // let lastRowRef = null;

    data?.forEach((columnData, index) => {
       sheet?.addRow(columnData);
      // lastRowRef = row;
    });

    workbook.csv.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "text/csv;charset=utf-8",
      });
      const url = globalThis.URL.createObjectURL(blob);
      const a = document.createElement("a");
      // document.body.appendChild(a);
      a.href = url;
      a.download =
        (title || "") +
        "_" +
        moment(arg?.startDate).format("MM-DD-YYYY") +
        "_to_" +
        moment(arg?.endDate).format("MM-DD-YYYY") +
        "_of_" +
        moment().format("MM-DD-YYYY");
      a.click();
      globalThis.URL.revokeObjectURL(url);
      // document.body.removeChild(a);
    });
  };

  const exportRates = async () => {
    let dateHeader = ["cate"];
    let dateArray = [];
    const startDate = moment(arg?.startStr);
    const endDate = moment(arg?.endStr);

    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.GET_MARKET_ANALYSIS_RATE +
        `?start_date=${moment(arg?.startStr).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(arg?.endStr).format("YYYY-MM-DD")}`
    );
    let objHead = {};
    let allDates = [];
    // Generate all dates in sequence
    for (
      let m = moment(startDate);
      m.isSameOrBefore(endDate);
      m.add(1, "day")
    ) {
      const formattedDate = m.format("YYYY-MM-DD");
      allDates.push(formattedDate);
      if (!dateHeader.includes(formattedDate)) {
        dateHeader.push(formattedDate);
        objHead[formattedDate] = m.format("DD-MMM-YY");
      }
    }
    objHead["cate"] = "";
    dateArray.push(objHead);

    if (result?.status === 200) {
      setLoading(false);

      resources
        ?.filter((item) => item?.id !== "average")
        ?.toReversed()
        ?.forEach((items) => {
          let obj = { cate: items?.competitor_hotel_name };
          allDates.forEach((date) => {
            const rateData = result?.data?.find(
              (item) =>
                item?.competitor_hotel_id === items?.id && item?.date === date
            );
            obj[date] = rateData ? `$${rateData?.rate}` : "-"; // Default to "$0" if missing
          });

          dateArray?.push(obj);
        });
      let objA = { cate: "Average Price" };
      allDates.forEach((date) => {
        let avgFilData = result?.data?.filter(
          (it) =>
            it?.date === date &&
            resources
              ?.map((item) => item?.id)
              ?.includes(it?.competitor_hotel_id)
        );
        let avgPrice =
          avgFilData?.reduce((sum, item) => sum + +item?.rate, 0) /
          avgFilData.length;
        objA[date] = avgPrice ? `$${avgPrice?.toFixed(2)}` : "-";
      });
      dateArray.push(objA);
    } else {
      setLoading(false);
    }
    exportToExcel(marketHotelList , dateHeader, dateArray, "Market_Rates");
  };

  const renderEventContent = (eventInfo) => {
    return (
      <div className="cale-event">
        {eventInfo?.event?.title && (
          <div
            className="d-flex justify-content-center w-90"
            style={{
              padding: "8px",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ color: "black", width: "100%", textAlign: "center" }}>
              {eventInfo.event.title}
            </div>
          </div>
        )}
      </div>
    );
  };

    const limitedMinDate = getMinDateForLimited();
    const limitedMinDateString = limitedMinDate ? limitedMinDate.format("YYYY-MM-DD") : null;
  

  return (
    <div>
      {(loading || loadingRate) && <Loader />}
      <div style={{ background: "#fff", width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Button
            size="large"
            variant="contained"
            disableElevation
            className="comman-button"
            color="primary"
            onClick={handleToday}
          >
            {t("Today")}
          </Button>
          <div>
            <Button
              size="large"
              variant="contained"
              disableElevation
              className="comman-button"
              sx={{
                borderTopRightRadius: "0px !important",
                borderBottomRightRadius: "0px !important",
                paddingRight: "5px !important",
              }}
              color="primary"
              onClick={handlePrev}
            >
              <ArrowBackIosIcon />
            </Button>
            <Button
              size="large"
              variant="contained"
              disableElevation
              className="comman-button"
              sx={{
                borderTopLeftRadius: "0px !important",
                borderBottomLeftRadius: "0px !important",
                paddingLeft: "5px !important",
              }}
              color="primary"
              onClick={handleNext}
            >
              <ArrowForwardIosIcon />
            </Button>
          </div>
          <Button
            variant="outlined"
            // className="m-1"
            sx={{
              border: "1px solid #BFBFBF",
              marginRight: "10px",
              padding: "7px",
              borderRadius: "12px",
            }}
            onClick={() => handleGetRateData(arg)}
          >
            <SyncIcon sx={{ fontSize: "18px" }} />
          </Button>
          <Grid container spacing={2} sx={{ width: "fit-content" }}>
            <Grid item lg={12} md={12} style={{ marginRight: "10px" }}>
              <FormControl size="small">
                <DatePicker
                  format="MM/DD/YYYY"
                  value={
                    calenderView?.initialDate
                      ? moment(calenderView?.initialDate, "YYYY-MM-DD")
                      : null
                  }
                  onChange={(newValue) =>{
                    setCalenderView({
                      initialDate: newValue
                        ? moment(newValue).format("YYYY-MM-DD")
                        : "",
                    })}
                  }
                  minDate={limitedMinDate}
                  inputProps={{
                    style: {
                      padding: "3px",
                      borderRadius: "12px",
                    },
                  }}
                  sx={{
                    width: "fit-content",
                    maxWidth: "150px",
                    input: {
                      padding: "3px!important",
                      borderRadius: "12px !important",
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px !important",
                    },
                    borderRadius: "12px",
                  }}
                  slotProps={{
                    textField: {
                      readOnly: true,
                    },
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <FormControl sx={{ m: 0, marginRight: "10px" }} size="small">
            <Select
              value={calenderView?.perMonth}
              onChange={(e) =>{
                setCalenderView({
                  perMonth: e.target.value,
                })}
              }
              sx={{ height: "34px", borderRadius: "12px" }}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={7}>{t("For One Week")}</MenuItem>
              <MenuItem value={14}>{t("For Two weeks")}</MenuItem>
              <MenuItem value={31}>{t("For One Month")}</MenuItem>
              <MenuItem value={60}>{t("For Two Month")}</MenuItem>
              <MenuItem value={88}>{t("For Three Months")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <div className="mt-2 market-analysis">
          <FullCalendar
            ref={calendarRef}
            initialDate={calenderView?.initialDate}
            key={calenderView?.initialDate}
            schedulerLicenseKey={"CC-Attribution-NonCommercial-NoDerivatives"} // Will need to purchase a license
            plugins={[
              interactionPlugin,
              resourceTimelinePlugin,
              multiMonthPlugin,
              dayGridPlugin,
            ]}
            locale={localStorage.getItem("lng") || "en"}
            locales={allLocales}
            // today prev,next
            headerToolbar={{
              right: "customButton1 customButton2", // Add 'customButton' to the left side
              left: "title",
            }}
            customButtons={{
              customButton1: {
                text: t("Export Rates"),
                click: () => exportRates(),
              },
              customButton2: {
                text: t("Add Market Rate"),
                click: () => setAddMarketRatesDialog(true),
              },
            }}
            events={eventss}
            eventContent={renderEventContent}
            resources={resources}
            resourceAreaColumns={columns}
            initialView="resourceTimelineWeek"
            views={{
              resourceTimelineWeek: {
                duration: { days: calenderView?.perMonth },
                slotDuration: "24:00:00",
                slotLabelFormat: [
                  { weekday: "short", day: "2-digit", month: "short" },
                ],
                titleFormat: { day: "2-digit", month: "short" },
              },
            }}
            slotLabelContent={(slotInfo) => {
              const dayOfWeek = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  weekday: "short",
                }
              );
              const dayOfMonth = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  day: "numeric",
                }
              );
              const month = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  month: "short",
                }
              );

              return (
                <div style={{ lineHeight: "18px", paddingInline: "15px" }}>
                  <div>{dayOfWeek}</div>
                  <div>{dayOfMonth}</div>
                  <div>{month}</div>
                </div>
              );
            }}
            datesSet={(argO) => {
              if (
                !(
                  argO?.startStr === arg?.startStr &&
                  argO?.endStr === arg?.endStr
                )
              ) {
                setArg(argO);
                if(calenderView?.initialDate !== moment(argO?.startStr).format("YYYY-MM-DD") || eventss?.length === 0){
                setLoadingRate(true);
              }
                setCalenderView({
                  initialDate: moment(argO?.startStr).format("YYYY-MM-DD"),
                });
              }
            }}
            dragScroll
            resourceAreaWidth="42%"
            validRange={{ start: limitedMinDateString }}
            height={"auto"}
          />
        </div>
        {/* Market Analysis */}
        {/* add market rates */}

        <DialogForm
          scroll="paper"
          maxWidth="xs"
          title={t("Add Market Rate")}
          openDialog={addMarketRatesDialog}
          handleDialogClose={() => setAddMarketRatesDialog(false)}
          bodyContent={
            <div className="p-2" style={{ height: "auto" }}>
              {loading && <SpinnerGlobal />}

              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Typography
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "500 !important",
                      }}
                    >
                      {t("Start Date")}
                    </Typography>

                    <DatePicker
                      format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                      value={moment(marketFilters.startDate, "YYYY-MM-DD")}
                      minDate={moment().add(1, "days")}
                      onChange={(e) => {
                        setMarketFilters((prevState) => ({
                          ...prevState,
                          startDate: moment(e).format("YYYY-MM-DD"),
                          endDate: moment(prevState?.endDate).isBefore(e)
                            ? moment(e).add(1, "days").format("YYYY-MM-DD")
                            : prevState?.endDate,
                        }));
                      }}
                      slotProps={{
                        textField: {
                          readOnly: true,
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Typography
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: "500 !important",
                      }}
                    >
                      {t("End Date")}
                    </Typography>

                    <DatePicker
                      format="MM/DD/YYYY" // Ensures MM/DD/YYYY format
                      minDate={moment(
                        marketFilters.startDate,
                        "YYYY-MM-DD"
                      ).add(1, "days")} // Correct way to set minDate
                      maxDate={moment(
                        marketFilters.startDate,
                        "YYYY-MM-DD"
                      ).add(60, "days")} // Correct way to set minDate
                      value={moment(marketFilters.endDate, "YYYY-MM-DD")}
                      onChange={(e) => {
                        setMarketFilters((prevState) => ({
                          ...prevState,
                          endDate: moment(e).format("YYYY-MM-DD"),
                        }));
                      }}
                      slotProps={{
                        textField: {
                          readOnly: true,
                        },
                      }}
                    />
                    <Grid item xs={12} className="mt-2 d-flex ">
                      <Button
                        onClick={handleAddMarketRates}
                        className="comman-button"
                      >
                        {t("Submit")}
                      </Button>
                    </Grid>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          }
        />
      </div>

      {/* delete Hotel Dialog */}
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to delete this hotel?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Delete")}
        openDialog={openDeleteHotelDialog}
        handleDialogClose={handleCloseDeleteHotelDialog}
        handleDialogAction={handleConfirmDeleteHotel}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    marketHotelList: state.roomRate.marketHotelList,
    calenderView: state.revenueGeneration.marketAnalysisCalenderView,
    ownHotelId: state.revenueGeneration.marketAnalysisOwnHotelId,
    resources: state.revenueGeneration.marketAnalysisResources,
    eventss: state.revenueGeneration.marketAnalysisEventss,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    marketHotelListSuccess: (data) => dispatch(marketHotelListSuccess(data)),
    marketHotelListFailed: () => dispatch(marketHotelListFailed()),
    marketAnalysisCalenderViewSuccess: (data) =>
      dispatch(marketAnalysisCalenderViewSuccess(data)),
    setOwnHotelId: (data) => dispatch(marketAnalysisOwnHotelIdSuccess(data)),
    setResourcess: (data) => dispatch(marketAnalysisResourcesSuccess(data)),
    setreservationEventss: (data) =>
      dispatch(marketAnalysisEventssSuccess(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketAnalysis);
